import { ReactElement, ReactNode } from 'react'
import { CircularProgress } from '@mui/material'
import { HeaderBadge } from '@ui/structure'

interface Props {
  isRunning: boolean
  children: ReactNode
}

/**
 * A spinner badge on the navbar button while a turn is running, so the user
 * sees activity even with the chat closed. Closing the chat never cancels
 * a run: the agent lives in the CopilotKit core, not in the drawer.
 */
const RunStatusBadge = ({ isRunning, children }: Props): ReactElement => (
  <HeaderBadge
    color="primary"
    invisible={!isRunning}
    badgeContent={<CircularProgress size={10} sx={{ color: 'common.white' }} />}
  >
    {children}
  </HeaderBadge>
)

export default RunStatusBadge
